<mat-card id="card" fxLayout="column" class="mainContentBody">
    <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
        <h2>Gestione colloqui conoscitivi</h2>
        <div fxLayout="column" class="responsive-mat-form">
          <mat-form-field>
            <input matInput [(ngModel)]="parameters.filter" placeholder="Filter"/>
          </mat-form-field>
        </div>
        <mat-card-actions>
          <button mat-raised-button id="search-button" (click)="list()" name="Search" color="primary">Search</button>
          <button mat-raised-button id="new-button" [routerLink]="['/colloquio-conoscitivo/detail/0']">New</button>
        </mat-card-actions>
        <br/>
        <div *ngIf="parameters.showList" fxLayout="column">
          <table mat-table fxFlex matTableExporter #exporter="matTableExporter" [hiddenColumns]="hiddenColumns()"
            matSort (matSortChange)="setSort($event)" matSortDisableClear 
            [dataSource]="parameters.dataSource">
        
            <!-- Id Column -->
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
              <td mat-cell *matCellDef="let colloquio"> {{ colloquio.id }} </td>
            </ng-container>
            
            <!-- Description Column -->
            <ng-container matColumnDef="nome">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Nome </th>
              <td mat-cell *matCellDef="let colloquio"> {{ colloquio.nome }} </td>
            </ng-container>
            
            <!-- Sede Column -->
            <ng-container matColumnDef="cognome">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Cognome </th>
              <td mat-cell *matCellDef="let colloquio"> {{ colloquio.cognome }} </td>
            </ng-container>

            <!-- Voto Column -->
            <ng-container matColumnDef="voto">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Voto </th>
              <td mat-cell *matCellDef="let colloquio"> {{ colloquio.voto }} </td>
            </ng-container>

            <!-- Descrizione Column -->
            <ng-container matColumnDef="descrizione">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Descrizione </th>
              <td mat-cell *matCellDef="let colloquio" class="limitaTesto"> {{ colloquio.descrizione.slice(0, maxDescMostrata) + (colloquio.descrizione.length > maxDescMostrata ? '...' : '') }} </td>
            </ng-container>

            <!-- Data Column -->
            <ng-container matColumnDef="dataColloquio">
              <th mat-header-cell *matHeaderCellDef mat-sort-header > Data </th>
              <td mat-cell *matCellDef="let colloquio"> {{ colloquio.dataColloquio }} </td>
            </ng-container>

            <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let colloquio">
                  <button mat-mini-fab color="primary" [routerLink]="['/colloquio-conoscitivo/detail/', colloquio.id]"><mat-icon>search</mat-icon></button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div fxLayout="row" fxLayoutAlign="space-between center">
            <mat-card-actions>
                <button mat-raised-button (click)="exporter.exportTable('xlsx', {fileName:'colloqui-conoscitivi'})">Excel</button>
                <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('csv', {fileName:'colloqui-conoscitivi'})">Csv</button>
                <button fxHide fxShow.gt-md mat-raised-button (click)="exporter.exportTable('json', {fileName:'colloqui-conoscitivi'})">Json</button>
            </mat-card-actions>
            <mat-paginator [pageSize]="parameters.pageSize" [pageIndex]="parameters.pageNumber" [length]="parameters.length" [pageSizeOptions]="[10,50,100]" (page)="setPaginator($event)"></mat-paginator>
          </div>
      </div>

    </mat-card-content>
  </mat-card>
